import { Card, Flex, Stack } from '@mantine/core';
import { secondaryBase } from '../../../styles/design-tokens';
import { Icon } from '../../../ui-library/icon/icon';
import { Text } from '../../../ui-library/typography/typography';

export const NoWorkPeriodSelected = () => {
  return (
    <Flex
      justify="center"
      align="center"
      style={{
        minHeight: 'calc(100vh - 250px)',
        width: '100%',
      }}
    >
      <Card
        padding="xl"
        radius="md"
        style={{
          width: '416px',
          height: '240px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
        }}
      >
        <Stack align="center" gap="md">
          <Icon name="calendar_month" variant="outlined" size={40} color={secondaryBase} />
          <Text weight="medium" size="large">
            No work period selected
          </Text>
          <Text style={{ textAlign: 'center' }}>
            Select a work period or date range to view phase distribution data.
          </Text>
        </Stack>
      </Card>
    </Flex>
  );
};
